import '../../../assets/style.css';
import '../../../assets/editor.css';

(function (blocks, blockEditor, i18n, element, components) {
	const { __ } = i18n;
	const { InnerBlocks, InspectorControls, useBlockProps } = blockEditor;
	const { PanelBody, ToggleControl, SelectControl, Notice, ExternalLink } = components;

	const TEMPLATE = [
		['core/paragraph', { content: __('This content is locked. Please sign in to continue.', 'wp-gated-content-block') }],
	];

	blocks.registerBlockType('crispycohd/gated-content', {
		apiVersion: 3,
		title: __('Gated Content (Lite)', 'wp-gated-content-block'),
		icon: 'lock',
		category: 'design',
		attributes: {
			restrictedLogin: { type: 'string', default: 'none' },
			fade: { type: 'boolean', default: true },
		},
		supports: { html: false, align: ['wide', 'full'] },

		edit: (props) => {
			const { attributes, setAttributes } = props;
			const { restrictedLogin, fade } = attributes;

			const blockProps = useBlockProps({ className: 'crispycohd-gc-editor-wrap' });

			return (
				<>
					<InspectorControls>
						<PanelBody title={__('Gate settings', 'wp-gated-content-block')} initialOpen={true}>
							<SelectControl
								label={__('Restrict content for', 'wp-gated-content-block')}
								help={__('Choose which visitors should be blocked at the gate. The rest of the post will be hidden for those visitors.', 'wp-gated-content-block')}
								value={restrictedLogin}
								options={[
									{ label: __('No restriction', 'wp-gated-content-block'), value: 'none' },
									{ label: __('Logged-out visitors', 'wp-gated-content-block'), value: 'logged-out' },
									{ label: __('Logged-in users', 'wp-gated-content-block'), value: 'logged-in' },
								]}
								onChange={(v) => setAttributes({ restrictedLogin: v })}
							/>

							<ToggleControl
								label={__('Fade the content above the gate', 'wp-gated-content-block')}
								help={__('Adds a subtle fade overlay above the gate to visually indicate the content continues below.', 'wp-gated-content-block')}
								checked={!!fade}
								onChange={(v) => setAttributes({ fade: !!v })}
							/>

							<Notice status="info" isDismissible={false}>
								{__('Want roles, WooCommerce purchases, subscriptions, user meta conditions, and more?', 'wp-gated-content-block')}{' '}
								<ExternalLink href={(window.crispycohdGcData && window.crispycohdGcData.upgradeUrl) ? window.crispycohdGcData.upgradeUrl : 'https://crispycohd.com/products/wp-gated-content-block'}>
									{__('Get Pro', 'wp-gated-content-block')}
								</ExternalLink>
							</Notice>
						</PanelBody>
					</InspectorControls>

					<div {...blockProps}>
						<InnerBlocks template={TEMPLATE} templateLock={false} />
					</div>
				</>
			);
		},

		save: () => {
			return (
				<div {...useBlockProps.save({ className: 'crispycohd-gc-gate' })}>
					<InnerBlocks.Content />
				</div>
			);
		},
	});
})(window.wp.blocks, window.wp.blockEditor, window.wp.i18n, window.wp.element, window.wp.components);
